/**
 * Calculates the total result count from an array of items.
 */
export function getTotalResultCount(
  items: Array<{ resultCount: number }>,
): number {
  return items.reduce((sum, item) => sum + Number(item.resultCount), 0);
}
